// extracted by mini-css-extract-plugin
var _1 = "IhtShE37gII1t2ovvfwg";
export { _1 as "htmlCell" }
export default { "htmlCell": _1 }
